import {
  HIDE_NAV_BAR,
  SHOW_NAV_BAR,
  NAV_BAR_HOME,
  NAV_BAR_STORY,
  NAV_BAR_PRINT_STORE,
  NAV_BAR_MODAL,
  NAV_BAR_FEED,
  SHOW_TERMS,
  SHOW_HOME
} from 'shared/actions/types';

import {
  LOGOUT
} from 'shared/actions/types';

export const hideNavBar = () => dispatch => {
  dispatch({
    type: HIDE_NAV_BAR
  });
}

export const showNavBar = () => dispatch => {
  dispatch({
    type: SHOW_NAV_BAR
  });
}

export const showNavBarHome = () => dispatch => {
  dispatch({
    type: NAV_BAR_HOME
  });
}

export const showNavBarStory = () => dispatch => {
  dispatch({
    type: NAV_BAR_STORY
  });
}

export const showNavBarPrintStore = () => dispatch => {
  dispatch({
    type: NAV_BAR_PRINT_STORE
  });
}

export const showNavBarModal = () => dispatch => {
  dispatch({
    type: NAV_BAR_MODAL
  });
}

export const showNavBarFeed = () => dispatch => {
  dispatch({
    type: NAV_BAR_FEED
  });
}

export const logOut = () => dispatch => {
  dispatch({
    type: LOGOUT
  });
}

export const showTerms = (url) => dispatch => {
  dispatch({
    type: SHOW_TERMS,
    payload: url
  });
}

export const showHome = () => dispatch => {
  dispatch({
    type: SHOW_HOME,
  });
}